import { MIN_KEYWORD_LENGTH } from "./keywordValidation";
import { normalizeSearchPhrase, searchPhraseKey } from "./searchPhrase";

/**
 * Splits a phrase list separated by commas or new lines: normalizes each part (trim, inner
 * whitespace collapsed to one space), drops normalized parts shorter than
 * MIN_KEYWORD_LENGTH code points and duplicates of an earlier kept part by
 * `searchPhraseKey` (case- and spacing-insensitive). Order is preserved; over-length phrases are kept (the
 * request layer refuses to send them).
 */
export function parsePrioritySearchPhrases(input: string): string[] {
  const seen = new Set<string>();
  const phrases: string[] = [];
  for (const part of input.split(/[,\n]/)) {
    const phrase = normalizeSearchPhrase(part);
    if (Array.from(phrase).length < MIN_KEYWORD_LENGTH) continue;
    const key = searchPhraseKey(phrase);
    if (seen.has(key)) continue;
    seen.add(key);
    phrases.push(phrase);
  }
  return phrases;
}
